import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Features from '../views/Features.vue'
import Download from '../views/Download.vue'
import Purchase from '../views/Purchase.vue'
import Contact from '../views/Contact.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Profile from '../views/Profile.vue'
import EditProfile from '../views/EditProfile.vue'
import TestModalView from '../views/TestModalView.vue'
import OrderCenter from '../views/OrderCenter.vue'
import BlogView from '../views/BlogView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/features',
    name: 'Features',
    component: Features
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  },
  {
    path: '/purchase',
    name: 'Purchase',
    component: Purchase
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/edit-profile',
    name: 'EditProfile',
    component: EditProfile
  },
  
  {
    path: '/test',
    name: 'TestModal',
    component: TestModalView
  },
  {
    path: '/order-center',
    name: 'OrderCenter',
    component: OrderCenter
  },
  {
    path: '/blog',
    name: 'Blog',
    component: BlogView
  },

  // 通配符路由，用于处理未匹配的路径
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
